import { isDomContentLoaded } from '../../../modules/get_perfomance'
import { getQueryParam } from '../../../modules/get_query'
import { setUrlMap } from '../../../modules/get_apiUrlString'
import { set_redirect404 } from '../../../modules/set_redirectUrl'

export default () => {

  // player_idがパラメータになかった時
  const playerId = getQueryParam('player_id');
  if (!playerId) {
    set_redirect404();
    return
  }

  const init = () => {
    setUrlMap(window.pist6);
    const worker = new Worker('/assets/js/data/worker/api_thread_player.js');
    const postData = Object.assign({playerId}, window.pist6);
    worker.postMessage(postData);

    worker.addEventListener('message', evt => {
      // データなし（該当データなし）の場合にリダイレクト
      if (evt.data.type == 'error') {
        set_redirect404();
        return;
      }

      if (isDomContentLoaded()) {
        buildContents(evt.data);
      } else {
        window.addEventListener('DOMContentLoaded', () => {
          buildContents(evt.data);
        })
      }
    })
  }

  const buildContents = (data) => {
    console.log(data);
    buildPlayerHeader(data.player);
    buildPlayerCard(data.player);
    buildGradeTotal(data.grade.totalStr);
    buildGradeTitle(data.grade.titleStr);
    buildGradeResult(data.grade.resultStr);

    document.body.buildGradeTables && document.body.buildGradeTables();
  }

  // 返却されたデータにより選手名の書き換え
  const buildPlayerHeader = (player) => {
    const playerHeader = document.querySelector('.at-detail__header');

    if (player.name_jp) {
      playerHeader.querySelector('.at-detail__ttl-sub').innerHTML = player.name_en.replace('<br>', '&nbsp;');
      playerHeader.querySelector('.at-detail__ttl-main').textContent = player.name_jp;
    } else {
      playerHeader.querySelector('.at-detail__ttl-sub').remove()
      playerHeader.querySelector('.at-detail__ttl-main').innerHTML = player.name_en.replace('<br>', '&nbsp;');
      playerHeader.querySelector('.at-detail__ttl-main').classList.add('_en');
    }

    playerHeader.removeAttribute('aria-hidden');
    playerHeader.classList.remove('_skelton');
  }
  // 返却されたデータにより選手カード（表裏）の構築
  const buildPlayerCard = (player) => {
    const playerCard = document.querySelector('.at-detail__card');
    playerCard.setAttribute('data-player-id', player.id)

    const playerCardImg = playerCard.querySelector('.at-detail__img');
    const playerCardImgLink = `${window.pist6.imgOrigin}/player_card/${player.id}/1384x1840.jpg`;
    playerCardImg.innerHTML = `<img class="at-detail__img-entity" src="${playerCardImgLink}" alt="${player.name_jp || player.name_en}" onerror="this.src='/assets/images/common/card/img_card_front_noimage.jpg'">`;

    const PlayerBackArea = playerCard.querySelector('.at-detail__param-inner');
    // 選手カード裏面の生成
    PlayerBackArea.innerHTML = player.backStr;

    playerCard.removeAttribute('aria-hidden');
    playerCard.classList.remove('_skelton');
  }

  // 返却されたデータにより通算成績の構築
  const buildGradeTotal = (gradeStr) => {
    const gradeTotal = document.getElementById('grade-total');

    const gradeBody = gradeTotal.querySelector('.at-grade-table__body');
    const trEle = gradeBody.querySelector('.at-grade-table__tr');
    const firstThEle = trEle.firstElementChild;
    trEle.innerHTML = gradeStr;
    trEle.firstElementChild.before(firstThEle);

    gradeTotal.classList.remove('_skelton');
    gradeTotal.removeAttribute('aria-hidden');
  }
  // 返却されたデータによりpist6タイトルの構築
  const buildGradeTitle = (gradeStrArr) => {
    const gradeTitle = document.getElementById('grade-title');

    const titleLayoutSlot = gradeTitle.closest('.at-grade__title');
    if (!gradeStrArr) {
      titleLayoutSlot.remove();
      return;
    }

    titleLayoutSlot.classList.remove('_hidden');

    buildGradeBody(gradeTitle, gradeStrArr);

    gradeTitle.classList.remove('_skelton');
    gradeTitle.removeAttribute('aria-hiddn');
  }
  // 返却されたデータによりレース戦績の構築
  const buildGradeResult = (gradeStrArr) => {
    const gradeResult = document.getElementById('grade-result');

    if (!gradeStrArr || !gradeStrArr.length) {
      gradeResult.closest('.at-grade__result').remove();
      return;
    }

    buildGradeBody(gradeResult, gradeStrArr);

    gradeResult.classList.remove('_skelton');
    gradeResult.removeAttribute('aria-hiddn');
  }

  // PIST6タイトル, レース戦績 共通処理
  const buildGradeBody = (gradeArea, gradeStrArr) => {
    const gradeBodyEleClassName = 'at-grade-table__body';
    const gradeBodyEle = gradeArea.querySelector(`.${gradeBodyEleClassName}`);
    gradeBodyEle.innerHTML = gradeStrArr[0];

    if (gradeStrArr.length == 1) {
      gradeArea.querySelector('.at-grade-table__handle').remove();
    } else {
      const accordionGradeBody = document.createElement('div');
      accordionGradeBody.classList.add(gradeBodyEleClassName, '_hidden');
      accordionGradeBody.innerHTML = gradeStrArr[1];
      gradeBodyEle.after(accordionGradeBody);
    }
  }

  init();
}
